module.exports = __webpack_public_path__ + "static/media/onlogist.367a739a.svg";